import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";
import { PaymentResult } from "../models/payment-result.model";

export class MercadoPagoController {
 

    constructor(public _http: HttpClient) {
    }
    generatePix(key: string, paymentId: number): Promise<PaymentResult> {



        return this._http.get(API_ADDRESS + `/mercadopago/pix/${key}/${paymentId}`, httpOptionsDefault)
            .pipe(
                map(result => {


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: PaymentResult) => {


                return result;
            });

    }

    verifyPix(tefId:number): Promise<PaymentResult> {



        return this._http.get(API_ADDRESS + `/mercadopago/verifyPix/${tefId}`, httpOptionsDefault)
            .pipe(
                map(result => {


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: PaymentResult) => {


                return result;
            });

    }
}


